import { apiAgent } from "../../config/axiosConfig";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  updateLoadError,
  setLoadingState,
  setTestPlanBuildList,
} from "./testPlanBuildSlice";

const createBuild = createAsyncThunk(
  "createBuild",
  async ({ testPlanId, environmentSetId }, { dispatch, rejectWithValue }) => {
    await dispatch(setLoadingState(true));
    try {
      const response = await apiAgent({
        method: "POST",
        url: "/api/v1/test_plan_builds",
        data: {
          test_plan_id: testPlanId,
        },
      });
      if (response.status === 200) {
        await dispatch(setLoadingState(false));
        return response?.data;
      } else {
        await dispatch(setLoadingState(false));
        return rejectWithValue(response.data);
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

const getBuild = createAsyncThunk(
  "getBuild",
  async ({ testPlanBuildId }, { dispatch, rejectWithValue }) => {
    await dispatch(setLoadingState(true));
    try {
      const response = await apiAgent({
        method: "GET",
        url: `/api/v1/test_plan_builds/${testPlanBuildId}`,
      });
      if (response.status === 200) {
        await dispatch(setLoadingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
      await dispatch(setLoadingState(false));
    }
  }
);

const getAllBuilds = createAsyncThunk(
  "getAllBuilds",
  async (
    { testPlanId, projectId, pageNumber, pageSize, filters },
    { dispatch, rejectWithValue }
  ) => {
    let paramsObj = {
      page: pageNumber,
      page_size: pageSize,
    };
    if (testPlanId) paramsObj.test_plan_id = testPlanId;
    if (projectId) paramsObj.project_id = projectId;
    if (filters) paramsObj = { ...paramsObj, ...filters };
    await dispatch(setLoadingState(true));
    try {
      const response = await apiAgent({
        method: "GET",
        url: "/api/v1/test_plan_builds/",
        params: paramsObj,
      });
      if (response.status === 200) {
        await dispatch(setTestPlanBuildList(response?.data || []));
        await dispatch(setLoadingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
      await dispatch(setLoadingState(false));
    }
  }
);

const generateBuildReport = createAsyncThunk(
  "generateBuildReport",
  async ({ testPlanBuildId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiAgent({
        method: "POST",
        url: `/api/v1/test_plan_builds/${testPlanBuildId}/analyse`,
      });
      if (response.status === 200) {
        return response?.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

export { createBuild, getBuild, getAllBuilds, generateBuildReport };
